import React, { useState, useRef, useEffect } from "react";
import { Paper, Grid, styled } from "@mui/material";
// import playBtn from "../asset/images/home/playBtn.png";
import playBtn from "../asset/icons/squre_play_mini.png";
import { NavLink, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
// import { ShareSocial } from "react-share-social";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  RedditShareButton,
  EmailShareButton,
  PinterestShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  RedditIcon,
  EmailIcon,
  PinterestIcon,
  WhatsappIcon
} from 'react-share';
import "../asset/css/index.css";
import { array } from "prop-types";
import { toast } from "react-toastify";
import { Modal, Button } from 'react-bootstrap';


const axios = require("axios");
//  Set Item for Matrial Ui
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

//  Home page main function
function Home() {
  const sourceRef = useRef(null);
  const targetRef = useRef(null);

  const REACT_APP_ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
  const reactAppUrl = process.env.REACT_APP_URL;
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const [show, setShow] = useState({ share_embed: false });
  const style = {
    background: "transparent",
    borderRadius: 3,
    border: 0,
    color: "white",
  };
  const handleClose = (modal_name = '') => {
    if (modal_name != '') {
      setShow({ ...show, [modal_name]: false });
    }
  };
  const handleShow = (modal_name = '') => {
    if (modal_name != '') {
      setShow({ ...show, [modal_name]: true });
    }
  };

  const handleDoubleClick = () => {
    alert('Button was double-clicked!');
  };

  const [playing, setPlaying] = useState(false);

  //Share Button

  const setOpenSettingBarChange = () => {
    if (OpenSettingBar) setOpenSettingBar(false);
    else {
      if (socialMediaMenu) {
        setSocialMediaMenu(false);
        setOpenSettingBar(false);
      } else setOpenSettingBar(true);
    }
  };



  const [OpenSettingBar, setOpenSettingBar] = useState(false);
  const [currentPlayPlaylist, setCurrentPlayPlaylist] = useState('');

  // Social Media Menu Bar
  const [socialMediaMenu, setSocialMediaMenu] = useState(false);

  const navigate = useNavigate();

  const [morePoolOn, SetmorePoolOn] = useState(true);
  const [OpenMenuBar, setOpenMenuBar] = useState(false);
  const [LikeImage, SetLikeImage] = useState(false);

  // End
  const [PlayUrl, setPlayUrl] = useState("");
  const [UrlDetails, setUrlDetails] = useState("");
  const [PlaylistDetails, setPlaylistDetails] = useState([]);
  const [allPlaylistData, SetPlaylist] = useState([]);
  const [topPlaylistData, TopPlaylist] = useState([]);
  const [loadData, SetLoadData] = useState(false);
  const [allLiveVideolistData, SetLiveVideolist] = useState([]);
  const [allVideolistData, SetVideolist] = useState([]);
  const [allData, setallData] = useState("");
  const [videoIndex, setVideoIndex] = useState(0);
   const [actionType, setActionType] = useState("");
  const videoIndexx = (index) => {
    setVideoIndex(index + 1);
  };
  // Channel Data
  const [channelArray, SetChannelArray] = useState([]);
  const [allchannelArray, SetAllChannelArray] = useState([]);
  const [allPlaylistArray, SetAllPlaylistArray] = useState([]);
  const [RandomPoolData, SetRandomPoolData] = useState([]);
  const [MorePoolData, SetMorePoolData] = useState([]);
  const [HomePlayData, SetHomePlayData] = useState([]);

  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
    axios
      .get(process.env.REACT_APP_API_URL + "/playlist/getPlayListData", {
        headers: { Token: token },
      })
      .then((response) => {
        axios
          .get(process.env.REACT_APP_API_URL + "/homecontrol/getAlldata", {
            headers: { Token: token },
          }).then((res) => {



            for (let i = 0; i < response.data.length; i++) {
              for (let j = 0; j < response.data[i].videos.length; j++) {
                if (response.data[i].videos[j].likes_by != null && JSON.parse(sessionStorage.getItem("userDetails"))) {
                  // String Search

                  if (userDetails !== null && userDetails.user_id !== undefined &&
                    response.data[i].videos[j].likes_by.search(userDetails.user_id) != -1
                  ) {
                    response.data[i].videos[j].likesThisUser = true;
                  } else {
                    response.data[i].videos[j].likesThisUser = false;
                  }
                } else {
                  response.data[i].videos[j].likesThisUser = false;
                }
              }
            }



            const MorePoolPlaylist = [];
            const RandomPoolPlaylist = [];
            const HomePlayPlaylist = [];
            SetAllPlaylistArray(response.data);

            SetAllChannelArray(res.data);
            response.data.forEach(element => {
              if (element.locationStatus == "randomPool") {
                RandomPoolPlaylist.push(element);
                SetRandomPoolData(RandomPoolPlaylist);
              }
              if (element.locationStatus == "morePool") {
                MorePoolPlaylist.push(element);
                SetMorePoolData(MorePoolPlaylist);
              }
              if (element.locationStatus == "homePlay") {
                HomePlayPlaylist.push(element);
                SetHomePlayData(HomePlayPlaylist);
                setUrlDetails(HomePlayPlaylist[0].videos[0]);
                setPlayUrl(HomePlayPlaylist[0].videos[0].url);
                setCurrentPlayPlaylist(HomePlayPlaylist[0]._id);
                setPlaylistDetails(HomePlayPlaylist);
                SetVideolist(HomePlayPlaylist[0].videos);
              }
            });
          })
      });

    // Function to set the height
    const setHeight = () => {
      if (sourceRef.current && targetRef.current) {
        const sourceHeight = sourceRef.current.wrapper.clientHeight;
        targetRef.current.style.height = `${sourceHeight}px`;
      }
    };

    const intervalId = setInterval(() => {
      setHeight();
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
  //  Set Style For Home Page(main)
    try {
      document.body.style.backgroundRepeat = "repeat-y";
      document.body.style.height = "auto";
      var muiEl = document.getElementsByClassName("css-1g7fu7m-MuiContainer-root")[0];
      if (muiEl) { muiEl.style.maxWidth = "100%"; muiEl.style.paddingTop = "10px"; }
      var mainEl = document.getElementsByClassName("main-container")[0];
      if (mainEl) { mainEl.style.height = "100%"; mainEl.style.width = "100%"; }
      var footerEl = document.getElementsByClassName("footer")[0];
      if (footerEl) { footerEl.style.display = "none"; }
      var headerEl = document.getElementsByClassName("header")[0];
      if (headerEl) { headerEl.style.display = "flex"; }
    } catch(e) { console.log("Style setup error:", e); }














    // document.getElementsByClassName("header")[0].style.height = "unset";
  });
  var allLiveVideos = [];
  useEffect(() => {
    //  Call All Playlist Data
    axios
      .get(process.env.REACT_APP_API_URL + "/playlist/getPlayListData")
      .then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].videos.length; j++) {
            if (res.data[i].videos[j].likes_by != null) {
              // String Search
              if (
                userDetails !== null &&
                userDetails.user_id !== undefined &&
                res.data[i].videos[j].likes_by.search(userDetails.user_id) != -1
              ) {
                res.data[i].videos[j].likesThisUser = true;
              } else {
                res.data[i].videos[j].likesThisUser = false;
              }
            } else {
              res.data[i].videos[j].likesThisUser = false;
            }
          }
        }
        SetPlaylist(res.data);
        // 1. Set top playlist using likes
        if (res.data.length != 0) {
          if (res.data[0].videos.length != 0) {
            setPlayUrl(res.data[0].videos[0].url);
            setUrlDetails(res.data[0].videos[0]);
            SetVideolist(res.data[0].videos);
            setPlaylistDetails(res.data[0]);
          }
        }
        var tempPlaylistData = res.data;
        for (let i = 0; i < tempPlaylistData.length; i++) {
          var totalLikes = 0;
          for (let j = 0; j < tempPlaylistData[i].videos.length; j++) {
            totalLikes =
              totalLikes + parseInt(tempPlaylistData[i].videos[j].likes);
          }
          tempPlaylistData[i].likes = totalLikes;
        }
        var tempData = null;
        for (let i = 0; i < tempPlaylistData.length; i++) {
          for (let j = i + 1; j < tempPlaylistData.length; j++) {
            if (tempPlaylistData[i].likes < tempPlaylistData[j].likes) {
              tempData = tempPlaylistData[i];
              tempPlaylistData[i] = tempPlaylistData[j];
              tempPlaylistData[j] = tempData;
            }
          }
        }
        TopPlaylist(tempPlaylistData);
      })
      .catch((error) => {
        console.error("Playlist fetch error:", error.response?.data || error.message || error);
      });
  //
      axios
      .get(process.env.REACT_APP_API_URL + "/playlist/getVideoData", {
        headers: { Token: "sdsndsddbsbdjsfdbsfdJDSKDjldfsd" },
      })
      .then((res) => {
        // Set All Videos
        SetVideolist(res.data);
        // Set All Live Videos
        for (let index = 0; index < res.data.length; index++) {
          if (res.data[index].duration == 0) {
            var VideoIdis = "";
            let UslIs = res.data[index].url;
            let paramString = UslIs.split("?")[1];
            let queryString = new URLSearchParams(paramString);
            for (let pair of queryString.entries()) {
              VideoIdis = pair[1];
            }
            try {
               if (!VideoIdis) {
    console.warn("Video ID is missing, skipping API call.");
    return;
  }
              axios
                .get(
                  `https://www.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=` +
                    VideoIdis +
                    `&key=` +
                    process.env.REACT_APP_YOUTUBEAPIKEY
                )
                .then((videores) => {
                  if (videores.data.items) {
                    if (videores.data.items.liveBroadcastContent == "live") {
                      allLiveVideos.push(res.data[index]);
                      SetLiveVideolist((allLiveVideos) => [
                        ...allLiveVideos,
                        res.data[index],
                      ]);
                    }
                  }
                })
                .catch((error) => {
                  // console.error("YouTube live video fetch error:", error.response?.data || error.message || error);
                });
            } catch (error) {
              // console.error("YouTube try block error:", error.message || error);
            }
          }
        }
      })
      .catch((error) => {
       // console.error("Video data fetch error:", error.response?.data || error.message || error);
      });
  }, []);
  
  // Get Location
  const [CurrentLocationData, SetCurrentLocationData] = useState(
    new Date().toString().split("(")[1].split(" ")[0]
  );
  // End Location
  var playThumbnail = [];
  useEffect(() => {
    if (topPlaylistData.length != 0) {
      for (let i = 0; i < topPlaylistData.length; i++) {
        for (let j = 0; j < 1; j++) {
          if (topPlaylistData[i].videos.length != 0)
            playThumbnail.push(topPlaylistData[i].videos[j].thumbnail);
          else if (topPlaylistData[i].videos.length == 0) {
            topPlaylistData.splice(i, 1);
          }
        }
      }
      for (let i = 0; i < topPlaylistData.length; i++) {
        topPlaylistData[i].image = playThumbnail[i];
      }
      SetLoadData(true);
    }
    if (allPlaylistData.length != 0) {
      for (let i = 0; i < allPlaylistData.length; i++) {
        for (let j = 0; j < 1; j++) {
          if (allPlaylistData[i].videos.length != 0)
            playThumbnail.push(allPlaylistData[i].videos[j].thumbnail);
          else if (allPlaylistData[i].videos.length == 0) {
            allPlaylistData.splice(i, 1);
          }
        }
      }
      for (let i = 0; i < allPlaylistData.length; i++) {
        allPlaylistData[i].image = playThumbnail[i];
      }
      SetLoadData(true);
    }
  }, []);
  const token = localStorage.getItem("token");

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "/user/getResspaceData", {
        headers: { Token: token },
      })
      .then((response) => {
        for (let index = 0; index < response.data.length; index++) {
          if (response.data.length >= 0) {
            setallData(response.data);
          }
        }
      });
  }, []);

  // const onEnded = () => {
  //   if (allVideolistData[videoIndex + 1]) {
  //     setVideoIndex(videoIndex + 1);
  //   }
  //   setUrlDetails(allVideolistData[videoIndex]);
  //   setPlayUrl(allVideolistData[videoIndex]?.url);
  // };
  //my code
  // const onEnded = () => {
  //   if (actionType === "skip") {
  //     // Skip to the next video in the playlist
  //     if (videoIndex < allVideolistData.length - 1) {
  //       setVideoIndex(videoIndex + 1); // Move to the next video
  //       setPlayUrl(allVideolistData[videoIndex + 1].url); // Update the URL
  //       setPlaying(true); // Auto play next video
  //     } else {
  //       setPlaying(false); // No more videos to play
  //     }
  //   } else if (actionType === "shuffle") {
  //     // Shuffle to a random video
  //     const randomIndex = Math.floor(Math.random() * allVideolistData.length); // Get a random index
  //     setVideoIndex(randomIndex); // Update the video index
  //     setPlayUrl(allVideolistData[randomIndex].url); // Update the video URL
  //     setPlaying(true); // Auto play the shuffled video
  //   } else {
  //     // Default behavior (if neither skip nor shuffle is pressed)
  //     if (videoIndex < allVideolistData.length - 1) {
  //       setVideoIndex(videoIndex + 1);  // Move to the next video
  //       setPlayUrl(allVideolistData[videoIndex + 1].url);  // Update the URL
  //       setPlaying(true); // Auto play next
  //     } else {
  //       setPlaying(false); // No more videos
  //     }
  //   }
  // };
const onEnded = () => {
  if (actionType === "skip") {
    // Skip to the next video in the playlist
    if (videoIndex < allVideolistData.length - 1) {
      setVideoIndex(videoIndex + 1); // Move to the next video
      setPlayUrl(allVideolistData[videoIndex + 1].url); // Update the URL
      setPlaying(true); // Auto play next video
    } else {
      setPlaying(false); // No more videos to play
    }
  } else if (actionType === "shuffle") {
    // Shuffle to a random video
    const randomIndex = Math.floor(Math.random() * allVideolistData.length); // Get a random index
    setVideoIndex(randomIndex); // Update the video index
    setPlayUrl(allVideolistData[randomIndex].url); // Update the video URL
    setPlaying(true); // Auto play the shuffled video
  } else {
    // Default behavior (if neither skip nor shuffle is pressed)
    if (videoIndex < allVideolistData.length - 1) {
      setVideoIndex(videoIndex + 1);  // Move to the next video
      setPlayUrl(allVideolistData[videoIndex + 1].url);  // Update the URL
      setPlaying(true); // Auto play next
    } else {
      setPlaying(false); 
    }
  }
};
  const onBack = () => {
    if (allVideolistData[videoIndex - 1]) {
      setVideoIndex(videoIndex - 1);
    }
    setUrlDetails(allVideolistData[videoIndex]);
    setPlayUrl(allVideolistData[videoIndex].url);
  };
  // copy Embed Code
  const [copySuccess, setCopySuccess] = useState("");
  const textAreaRef = useRef(null);
  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess("Copied!");
  }
  const MoveToNowPlaying = () => {
    document.getElementById("noanim-tab-example-tab-home").click();
  };
  const EmptyCopy = () => {
    setCopySuccess("");
  };

  // Like and dislike
  const LikeDislike = (video_id, likeopr) => {
    if (!sessionStorage.getItem("userDetails")) {
      toast.warning("Please Login First!");
      navigate("/login");
    } else {
      const user_id = (userDetails !== null && userDetails.user_id !== undefined) ? userDetails.user_id : '';
      axios
        .post(process.env.REACT_APP_API_URL + "/playlist/like", {
          user: user_id,
          video: video_id,
          opr: likeopr,
        })
        .then((res) => {
          console.log("Video Like");
        })
        .catch((err) => {
          console.log("error Video not like",err);
        });
    }
  };



  return (
    <>
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1237383458459832"
        crossorigin="anonymous"></script>
      <main >
        <div className="row" id="mainPlayerFirst">
          <div className=" col-sm-12 col-xs-12 col-lg-12 mb-3 order-lg-2 order-sm-first ">
            <div className="row borderRadius">
              <Grid
                item
                className="displayVideoBox my-2 borderRadius todayList mainDisplay pt-3 border-0"
              >
                <Item className="displayVideo pt-0 pb-0">
                  <div className="row flip_player_scren">
                    <div className="col-12 col-md-10 mt-3 flip_media flip_player_scren" >
                      <div
                        className="PlaylistPlayer__player-wrapper rounded overflow-hidden mb-2 flip_player_scren"
                        style={{ position: "relative" }}
                      >
                                  <ReactPlayer
                                    url={PlayUrl}
                                    className="PlaylistPlayer__player flip_player_scren"
                                    width="100%"
                                    height="100%"
                                    controls
                                    playing={playing}
                                    ref={sourceRef}
                                    onPlay={() => setPlaying(true)}
                                    onPause={() => setPlaying(false)}
                                    onEnded={() => {
                                      // Move to next video if exists
                                      if (videoIndex < allVideolistData.length - 1) {
                                        setVideoIndex(videoIndex + 1);
                                        setPlayUrl(allVideolistData[videoIndex + 1].url); 
                                          setPlaying(true); // autoplay next
                                      } else {
                                        setPlaying(false); // no more videos
                                      }
                                    }}
                                    
                                  />

                      </div>
                    </div>
                    <div className="col-md-2 m-none mt-3 flip_sideplaylist">
                      <div className="col-12 col-md-12 ">
                        <div
                          ref={targetRef}
                          className="row scrollbar-hide setHeigthofScroller pt-0 mainPlaylist bg-transparent flip_sidelist_height"
                          style={{ background: "#242424" }}
                        >
                          {/* Home */}
                          {allPlaylistArray.map((val1, index) => (val1.locationStatus == "homePlay" ?
                            (<>

                              <div className={(currentPlayPlaylist != '' && currentPlayPlaylist == val1._id ? 'main_active_video' : '') + (allPlaylistArray.map((playlist) => playlist.locationStatus).lastIndexOf('homePlay') == index ? '' : ' mb-3') + " videoItem p-0 mx-0 position-relative rounded-bottom overflow-hidden main-playlist-box"} style={{ display: "flex", flexWrap: "wrap", margin: "0", padding: "0" }} >
                                <Item className="aboutVideo transparent todayList bg-dark-opacity-50 custom-py-2 position-absolute start-0 end-0 d-flex align-items-center" style={{ zIndex: "1" }}>
                                  <img className="playBtn me-2" src={playBtn} alt="" style={{ width: "25px", height: "25px" }} />
                                  <span className="home_playlist_title overflow-hidden" title={val1.title} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", display: "inline-block", maxWidth: "100px" }}>{val1.title}</span>
                                </Item>
                                {
                                  (
                                    <>
                                      {val1.videos[0] != undefined && val1.videos[1] == undefined && val1.videos[2] == undefined && val1.videos[3] == undefined ? (
                                        <>
                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[0].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[0]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            alt=""
                                            className="w-100"
                                            style={{
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov")
                                                ? require('../asset/images/default-thumbnail.webp')
                                                : val1.videos[0].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              backgroundRepeat: 'no-repeat',
                                              width: '100%',
                                              height: '80px',
                                            }}
                                          />
                                        </>
                                      ) : (val1.videos[0] != undefined && val1.videos[1] != undefined && val1.videos[2] == undefined && val1.videos[3] == undefined ? (
                                        <>
                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[0].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[0]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov")
                                                ? require('../asset/images/default-thumbnail.webp')
                                                : val1.videos[0].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              backgroundRepeat: 'no-repeat',
                                              height: '80px',
                                              cursor: 'pointer',
                                              display: 'inline-block',
                                            }}
                                            className="w-50"
                                            aria-hidden="true"
                                          />

                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[1].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[1]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              backgroundImage: `url(${val1.videos[1].thumbnail.includes(".mp4") || val1.videos[1].thumbnail.includes(".mov")
                                                ? require('../asset/images/default-thumbnail.webp')
                                                : val1.videos[1].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              backgroundRepeat: 'no-repeat',
                                              height: '80px',
                                              cursor: 'pointer',
                                              display: 'inline-block',
                                            }}
                                            className="w-50"
                                            aria-hidden="true"
                                          />
                                          {/* <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[0].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[0]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              backgroundImage: `url('https://i.ytimg.com/vi/h0XvwqJIPbo/hqdefault.jpg')`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center center',
                                              backgroundRepeat: 'no-repeat',
                                              height: '80px',
                                              cursor: 'pointer',
                                              display: 'inline-block',
                                              width: '50%',
                                            }}
                                            aria-hidden="true"
                                          /> */}
                                          {/* <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[1].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[1]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              backgroundImage: `url('https://i.ytimg.com/vi/h0XvwqJIPbo/hqdefault.jpg')`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center center',
                                              backgroundRepeat: 'no-repeat',
                                              height: '80px',
                                              cursor: 'pointer',
                                              display: 'inline-block',
                                              width: '50%',
                                            }}
                                            aria-hidden="true"
                                          /> */}

                                        </>
                                      ) : (val1.videos[0] != undefined && val1.videos[1] != undefined && val1.videos[2] != undefined && val1.videos[3] == undefined ? (
                                        <>
                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[0].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[0]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              height: "80px",
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[0].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              width: "50%"
                                            }}
                                            className="thumbnail-container"
                                            alt=""
                                          />

                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[1].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[1]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              height: "80px",
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[1].thumbnail.includes(".mp4") || val1.videos[1].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[1].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              width: "50%"
                                            }}
                                            className="thumbnail-container"
                                            alt=""
                                          />

                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[2].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[2]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              height: "80px",
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[2].thumbnail.includes(".mp4") || val1.videos[2].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[2].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              width: "100%"
                                            }}
                                            className="thumbnail-container"
                                            alt=""
                                          />

                                        </>
                                      ) : (val1.videos[0] != undefined && val1.videos[1] != undefined && val1.videos[2] != undefined && val1.videos[3] != undefined ? (
                                        <>
                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[0].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[0]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              height: "80px",
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[0].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              width: "50%",
                                              display: 'inline-block'
                                            }}
                                            className="thumbnail-container"
                                            alt=""
                                          />

                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[1].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[1]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              height: "80px",
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[1].thumbnail.includes(".mp4") || val1.videos[1].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[1].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              width: "50%",
                                              display: 'inline-block'
                                            }}
                                            className="thumbnail-container"
                                            alt=""
                                          />

                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[2].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[2]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              height: "80px",
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[2].thumbnail.includes(".mp4") || val1.videos[2].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[2].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              width: "50%",
                                              display: 'inline-block'
                                            }}
                                            className="thumbnail-container"
                                            alt=""
                                          />

                                          <div
                                            onClick={() => {
                                              setPlayUrl(val1.videos[3].url);
                                              setCurrentPlayPlaylist(val1._id);
                                              setUrlDetails(val1.videos[3]);
                                              SetVideolist(val1.videos);
                                              setPlaylistDetails(val1);
                                            }}
                                            style={{
                                              height: "80px",
                                              cursor: "pointer",
                                              backgroundImage: `url(${val1.videos[3].thumbnail.includes(".mp4") || val1.videos[3].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[3].thumbnail})`,
                                              backgroundSize: 'auto 135%',
                                              backgroundPosition: 'center',
                                              width: "50%",
                                              display: 'inline-block'
                                            }}
                                            className="thumbnail-container"
                                            alt=""
                                          />

                                        </>
                                      ) : (""))))}




                                    </>
                                  )}
                              </div>

                            </>) : ("")))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flip_bottm_row_main" style={{ height: "12.6%" }}>
                    <div className="col-12">
                      <div className="row m-0 ">
                        <div className="col-12 col-md-10 border-right-color flip_bottm_left_col">
                          <div className="row">
                            <div className="col-12 col-md-8 p-0 flip_btmlis_firstcol" style={{ height: "68px" }}>
                              <ins class="adsbygoogle"
                                style={{ display: "block" }}
                                data-ad-client="ca-pub-1237383458459832"
                                data-ad-slot="3881532816"
                                data-ad-format="auto"
                                data-full-width-responsive="true"></ins>
                              {/* {allData[0] ? (
                                <img
                                  src={
                                    REACT_APP_ADMIN_URL+"/assets/images/reserved/" +
                                    allData[0].resimage
                                  }
                                  className="img-fluid"
                                  style={{ width: "100%", height: "68px" }}
                                  alt=""
                                />
                              ) : (
                                <img
                                  src={
                                    REACT_APP_ADMIN_URL+"/assets/images/reserved/"
                                  }
                                  className="img-fluid"
                                  alt=""
                                />
                              )} */}
                            </div>
                            <div
                              className="col-12 col-md-4 p-0 player_control_name_box border-left-color flip_media_icons_box"
                              style={{ color: "#fff" }}
                            >
                              {/* <div className="col-12 col-md-8 p-0 flip_btmlis_adsrow" style={{ height: "68px" }}>
                                <ins class="adsbygoogle"
                                  style={{ display: "block" }}
                                  data-ad-client="ca-pub-1237383458459832"
                                  data-ad-slot="3881532816"
                                  data-ad-format="auto"
                                  data-full-width-responsive="true"></ins>
                              </div> */}
                              <div className="h-100 control_name_section">
                                <div
                                  className="border-bottom-color fw-bolder home_player_title px-2 mw-50"
                                  title={UrlDetails?.title}
                                >
                                  {/* {UrlDetails
                                    ? UrlDetails?.title
                                    : "Untitled"} */}
                                    <marquee behavior="scroll" direction="left" scrollamount="4">
    {UrlDetails ? UrlDetails?.title : "Untitled"}
  </marquee>
                                </div>
                                <div className=" mw-50">
                                  <div className="row playlist_bottom_header1 w-100 m-auto">
                                    <div className="col-12 p-0 d-flex">
                                      <ul className="p-0 m-auto">
                                        <li
                                          style={{
                                            display: "inline"
                                          }}
                                        >
                                          <img
                                            onClick={() =>
                                              setOpenSettingBar(false)
                                            }
                                            onDoubleClick={handleDoubleClick}
                                            style={{
                                              cursor: "pointer",
                                              width: "28%",
                                            }}
                                            src={require(`../asset/images/LoginLogoZero.png`)}
                                            className="img-fluid p-1 flip_playrscrn_sitelogo"
                                            alt=""
                                          />
                                        </li>
                                        {/* <li
                                          onClick={() => {
                                            setOpenSettingBar(false);
                                          }}
                                          style={{ display: "inline" }}
                                          className="p-1"
                                        >
                                          <img
                                            onClick={onBack}
                                            src={require(`../asset/images/DoublePlayBack.webp`)}
                                            className="img-fluid m-auto"
                                            alt=""
                                            style={{
                                              width: "12%",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </li> */}

                                        <li
                                          onClick={() => {
                                            setOpenSettingBar(false);
                                          }}
                                          style={{ display: "inline" }}
                                        >
                                          <img
                                            onClick={() => { playing ? setPlaying(false) : setPlaying(true) }}
                                            src={playing ? require(`../asset/icons/pause_sq_w.png`) : require(`../asset/icons/play_sq_w.png`)}
                                            className="img-fluid m-auto mw-15 sdsd flip_playrscrn_icon"
                                            alt=""
                                            style={{
                                              width: "13%",
                                              cursor: "pointer",
                                              padding: "2px",
                                            }}
                                          />
                                        </li>

                                        <li
                                          onClick={() => {
                                            setActionType("shuffle"); 
                                            SetmorePoolOn(false);
                                          }}
                                          style={{ display: "inline" }}
                                        >
                                          <img
                                            onClick={onEnded}
                                            src={require(`../asset/icons/bold_shuffel.png`)}
                                            className="img-fluid m-auto mw-15 flip_playrscrn_icon"
                                            alt=""
                                            style={{
                                              width: "13%",
                                              cursor: "pointer",
                                              padding: "2px",
                                            }}
                                          />
                                        </li>

                                        {/* <li onClick={() => {
                                            setOpenSettingBar(false);
                                          }}
                                          style={{ display: "inline" }}
                                          className="p-1"
                                        >
                                          <img
                                            onClick={onEnded}
                                            src={require(`../asset/images/DoublePlayFront.webp`)}
                                            className="img-fluid m-auto p-1"
                                            alt=""
                                            style={{
                                              width: "16%",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </li> */}

                                        <li
                                          onClick={() => {
                                            setOpenSettingBar(false);
                                            setSocialMediaMenu(false);
                                          }}
                                          style={{ display: "inline" }}
                                        >
                                          {window.location.href.split("iid=")[1] ? (
                                            <img
                                              onClick={() =>
                                                alert("Please Login First")
                                              }
                                              style={{
                                                cursor: "pointer",
                                                width: "13%",
                                                padding: "2px",
                                              }}
                                              src={require(`../asset/icons/squre_heart_mini_empty.png`)}
                                              className="img-fluid m-auto mw-15 flip_playrscrn_icon"
                                              alt=""
                                            />
                                          ) : UrlDetails ? (
                                            LikeImage ? (
                                              <img
                                                style={{
                                                  cursor: "pointer",
                                                  width: "13%",
                                                }}
                                                onClick={() => {
                                                  LikeDislike(UrlDetails._id, "dislike");
                                                  SetLikeImage(false);

                                                }
                                                }
                                                src={require(`../asset/icons/squre_heart_mini.png`)}
                                                className="img-fluid m-auto mw-15 flip_playrscrn_icon"
                                                alt=""
                                              />
                                            ) : (
                                              <img
                                                style={{
                                                  cursor: "pointer",
                                                  width: "13%",
                                                  padding: "2px",
                                                }}
                                                onClick={() => {
                                                  LikeDislike(UrlDetails._id, "like");
                                                  SetLikeImage(true);

                                                }
                                                }
                                                src={require(`../asset/icons/squre_heart_mini_empty.png`)}
                                                className="img-fluid m-auto mw-15 flip_playrscrn_icon"
                                                alt=""
                                              />
                                            )
                                          ) : (
                                            <img
                                              onClick={() => alert("No Video Found")}
                                              style={{
                                                cursor: "pointer",
                                                width: "13%",
                                                padding: "2px",
                                              }}
                                              src={require(`../asset/icons/squre_heart_mini.png`)}
                                              className="img-fluid  m-auto p-1 mw-15 flip_playrscrn_icon"
                                              alt=""
                                            />
                                          )}
                                        </li>

                                        <li
                                          style={{
                                            display: "inline", position: "relative"
                                          }}
                                        >
                                          <ul
                                            className={
                                              OpenSettingBar
                                                ? "dropDownSettingHome"
                                                : "dropDownSettingHome hidden"
                                            }
                                          >
                                            <li
                                              style={{
                                                cursor: "pointer",
                                                width: "13%",
                                                padding: "2px",
                                              }}
                                              onClick={() => {
                                                setOpenSettingBar(false);
                                                setSocialMediaMenu(true);
                                              }}
                                              className=" mw-15"
                                              to="/"
                                            >
                                              Share to Social
                                            </li>
                                            <li
                                              style={{
                                                cursor: "pointer",
                                                width: "13%",
                                                padding: "2px",
                                              }}
                                              onClick={() => { handleShow('share_embed'); }}
                                              className=" mw-15 flip_playrscrn_icon"
                                              to="/playlist"
                                            >
                                              Share Embed
                                            </li>
                                          </ul>
                                          <ul
                                            className={
                                              socialMediaMenu
                                                ? "dropDownSettingHome"
                                                : "dropDownSettingHome hidden"
                                            }
                                            style={{ padding: "0 18px", width: "fit-content" }}
                                          >
                                            {socialMediaMenu ? (
                                              <div className="social-share-buttons d-flex w-fit-content">
                                                <FacebookShareButton url={reactAppUrl + "/playlist?id=" + currentPlayPlaylist} quote="Facebook" className="me-2 my-2">
                                                  <FacebookIcon size={32} round={true} />
                                                </FacebookShareButton>

                                                <TwitterShareButton url={reactAppUrl + "/playlist?id=" + currentPlayPlaylist} title="Twitter" className="me-2 my-2">
                                                  <TwitterIcon size={32} round={true} />
                                                </TwitterShareButton>

                                                <LinkedinShareButton url={reactAppUrl + "/playlist?id=" + currentPlayPlaylist} className="me-2 my-2">
                                                  <LinkedinIcon size={32} round={true} />
                                                </LinkedinShareButton>

                                                <RedditShareButton url={reactAppUrl + "/playlist?id=" + currentPlayPlaylist} title="Reddit" className="me-2 my-2">
                                                  <RedditIcon size={32} round={true} />
                                                </RedditShareButton>

                                                <EmailShareButton url={reactAppUrl + "/playlist?id=" + currentPlayPlaylist} subject="Email" className="me-2 my-2">
                                                  <EmailIcon size={32} round={true} />
                                                </EmailShareButton>

                                                <PinterestShareButton url={reactAppUrl + "/playlist?id=" + currentPlayPlaylist} className="me-2 my-2">
                                                  <PinterestIcon size={32} round={true} />
                                                </PinterestShareButton>

                                                <WhatsappShareButton url={reactAppUrl + "/playlist?id=" + currentPlayPlaylist} title="Whatsapp" className="me-2 my-2">
                                                  <WhatsappIcon size={32} round={true} />
                                                </WhatsappShareButton>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </ul>
                                          <img
                                            style={{
                                              cursor: "pointer",
                                              width: "13%",
                                              padding: "2px",

                                            }}
                                            onClick={() => {
                                              setOpenSettingBarChange();
                                              setOpenMenuBar(false);
                                            }}
                                            src={require(`../asset/icons/squre_share.png`)}
                                            className="img-fluid m-auto mw-15 flip_playrscrn_icon"
                                            alt=""
                                          />
                                        </li>

                                        <li onClick={() => {
                                           setActionType("skip"); 
                                          setOpenSettingBar(false);
                                        }}
                                          style={{ display: "inline" }}
                                          className=""
                                        >
                                          <img
                                            onClick={onEnded}
                                            
                                            src={require(`../asset/icons/skip.png`)}
                                            className="img-fluid m-auto flip_playrscrn_icon"
                                            alt=""
                                            style={{
                                              width: "13%",
                                              cursor: "pointer",
                                              padding: "2px",
                                            }}
                                          />
                                        </li>

                                        {/* <img style={{ cursor: "pointer" , width:'14%' }} onClick={setOpenMenuBar} src={require(`../asset/images/Button_goToUserPage2.png`)} className="img-fluid" alt="" /> */}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              onClick={() => {
                                setOpenSettingBar(false);
                              }}
                              className="col-12"
                            >
                              <div id="MainPlayerBelowVideos" className="row border-top-color">
                                <div className="col-12 col-md-12 d-inline-flex px-0 py-1" >
                                  <div className="horizontal-scrollbar" style={{
                                    width: "-webkit-fill-available",
                                    // display: "-webkit-box", overflow: "auto",
                                    display: "flex", // Use flex instead of -webkit-box
                                    overflow: "auto",
                                    flexWrap: allVideolistData.length === 1 ? "wrap" : "nowrap", // Apply wrap only for one column
                                  }}>
                                    {allVideolistData.map((videos, index) => (
                                     
   videos?.url && videos.thumbnail !== "https://i.ytimg.com/vi/7oKcaUIBf60/hqdefault.jpg" && !videos.thumbnail.includes(".mp4") && !videos.thumbnail.includes(".mov")  && !videos.thumbnail.includes("hqdefault_live.jpg") ? (

                                        <div
                                          className={(PlayUrl != '' && PlayUrl == videos?.url ? 'main_active_video' : '') + " rounded overflow-hidden me-1"}
                                          //  style={{minWidth:"86px" }}
                                          style={{
                                            minWidth:
                                              allVideolistData.length === 1
                                                ? "100%"
                                                : allVideolistData.length === 2
                                                ? "480px"
                                                : allVideolistData.length >= 3 && allVideolistData.length <= 6
                                                ? "220px"
                                                : allVideolistData.length >= 7 && allVideolistData.length <= 9
                                                ? "151px"
                                                : allVideolistData.length >= 10 && allVideolistData.length <= 12
                                                ? "133px"
                                                : "86px",
                                          
                                            flex: allVideolistData.length > 1 ? "0 0 auto" : "1 0 100%",
                                          
                                            ...(allVideolistData.length === 2 && { width: "50%" }),
                                            ...(allVideolistData.length === 5 && { width: "20%" })
                                          }}
                                          
                                            
                                        >
                                          {videos.thumbnail !== "" && !videos.thumbnail.includes(".mp4") && !videos.thumbnail.includes(".mov") ? (
                                            <div
                                              onClick={() => {
                                                setPlayUrl(videos.url);
                                                setUrlDetails(videos);
                                                setVideoIndex(index); // <-- ADD THIS LINE!
                                              }}
                                              style={{
                                                backgroundImage: `url(${videos.thumbnail})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                height: "5em",
                                                width: "100%",
                                                backgroundRepeat: "no-repeat",
                                                cursor: "pointer",
                                              }}
                                              className="flip_scrn_medialist"
                                            ></div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                     ) : null
                                    // ))}
                                    ))} 
                                  </div>
                                </div>
                                {/* <div className="col-12 col-md-1 bg-black">
                                  <div className="row">
                                    <div
                                      onClick={() => {
                                        SetmorePoolOn(true);
                                      }}
                                      style={{ cursor: "pointer" }}
                                      className="col-6 col-sm-12 p-1 d-flex mt-2"
                                    >
                                      <img
                                        src={require(`../asset/images/DoublePlayFront.webp`)}
                                        className="img-fluid m-auto ButtonNext"
                                        alt=""
                                        style={{ width: "54%" }}
                                      />
                                    </div>
                                    <div
                                      onClick={() => {
                                        SetmorePoolOn(false);
                                      }}
                                      style={{ cursor: "pointer" }}
                                      className="col-6 col-sm-12 d-flex p-0"
                                    >
                                      <img
                                        src={require(`../asset/images/Mix.webp`)}
                                        className="img-fluid m-auto ButtonMix"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 m-show flip_botm_medialist">
                          <div className="col-12 col-md-12">
                            <div
                              className="row scrollbar-hide setHeigthofScroller pt-3 h-100"
                              style={{ background: "#242424", maxHeight: "28rem" }}
                            >
                              {/* Home */}
                              {allPlaylistArray.map((val1, index) => (val1.locationStatus == "homePlay" ?
                                (<>
                                  <div className="common-border-bottom mb-2 pb-2">

                                    <div className={(currentPlayPlaylist != '' && currentPlayPlaylist == val1._id ? 'main_active_video' : '') + " videoItem p-0 mx-0 position-relative rounded-bottom overflow-hidden main-playlist-box col-8"} style={{ display: "flex", flexWrap: "wrap", margin: "0", padding: "0" }}>
                                      <Item className="aboutVideo transparent todayList bg-dark-opacity-50 custom-py-2 position-absolute start-0 end-0 d-flex align-items-center" style={{ zIndex: "1" }}>
                                        <img className="playBtn me-2" src={playBtn} alt="" style={{ width: "25px", height: "25px" }} />
                                        <span className="home_playlist_title overflow-hidden" title={val1.title} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", display: "inline-block", maxWidth: "100px" }}>{val1.title}</span>
                                      </Item>
                                      {
                                        (
                                          <>
                                            {val1.videos[0] != undefined && val1.videos[1] == undefined && val1.videos[2] == undefined && val1.videos[3] == undefined ? (
                                              <>
                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[0].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[0]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  alt=""
                                                  className="w-100"
                                                  style={{
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov")
                                                      ? require('../asset/images/default-thumbnail.webp')
                                                      : val1.videos[0].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    width: '100%',
                                                    height: '80px',
                                                  }}
                                                />
                                              </>
                                            ) : (val1.videos[0] != undefined && val1.videos[1] != undefined && val1.videos[2] == undefined && val1.videos[3] == undefined ? (
                                              <>
                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[0].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[0]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov")
                                                      ? require('../asset/images/default-thumbnail.webp')
                                                      : val1.videos[0].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    height: '80px',
                                                    cursor: 'pointer',
                                                    display: 'inline-block',
                                                  }}
                                                  className="w-50"
                                                  aria-hidden="true"
                                                />

                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[1].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[1]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    backgroundImage: `url(${val1.videos[1].thumbnail.includes(".mp4") || val1.videos[1].thumbnail.includes(".mov")
                                                      ? require('../asset/images/default-thumbnail.webp')
                                                      : val1.videos[1].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    height: '80px',
                                                    cursor: 'pointer',
                                                    display: 'inline-block',
                                                  }}
                                                  className="w-50"
                                                  aria-hidden="true"
                                                />
                                                {/* <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[0].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[0]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    backgroundImage: `url('https://i.ytimg.com/vi/h0XvwqJIPbo/hqdefault.jpg')`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center center',
                                                    backgroundRepeat: 'no-repeat',
                                                    height: '80px',
                                                    cursor: 'pointer',
                                                    display: 'inline-block',
                                                    width: '50%',
                                                  }}
                                                  aria-hidden="true"
                                                />
                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[1].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[1]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    backgroundImage: `url('https://i.ytimg.com/vi/h0XvwqJIPbo/hqdefault.jpg')`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center center',
                                                    backgroundRepeat: 'no-repeat',
                                                    height: '80px',
                                                    cursor: 'pointer',
                                                    display: 'inline-block',
                                                    width: '50%',
                                                  }}
                                                  aria-hidden="true"
                                                /> */}

                                              </>
                                            ) : (val1.videos[0] != undefined && val1.videos[1] != undefined && val1.videos[2] != undefined && val1.videos[3] == undefined ? (
                                              <>
                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[0].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[0]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    height: "80px",
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[0].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    width: "50%"
                                                  }}
                                                  className="thumbnail-container"
                                                  alt=""
                                                />

                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[1].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[1]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    height: "80px",
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[1].thumbnail.includes(".mp4") || val1.videos[1].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[1].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    width: "50%"
                                                  }}
                                                  className="thumbnail-container"
                                                  alt=""
                                                />

                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[2].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[2]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    height: "80px",
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[2].thumbnail.includes(".mp4") || val1.videos[2].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[2].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    width: "100%"
                                                  }}
                                                  className="thumbnail-container"
                                                  alt=""
                                                />

                                              </>
                                            ) : (val1.videos[0] != undefined && val1.videos[1] != undefined && val1.videos[2] != undefined && val1.videos[3] != undefined ? (
                                              <>
                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[0].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[0]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    height: "80px",
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[0].thumbnail.includes(".mp4") || val1.videos[0].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[0].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    width: "50%",
                                                    display: 'inline-block'
                                                  }}
                                                  className="thumbnail-container"
                                                  alt=""
                                                />

                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[1].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[1]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    height: "80px",
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[1].thumbnail.includes(".mp4") || val1.videos[1].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[1].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    width: "50%",
                                                    display: 'inline-block'
                                                  }}
                                                  className="thumbnail-container"
                                                  alt=""
                                                />

                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[2].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[2]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    height: "80px",
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[2].thumbnail.includes(".mp4") || val1.videos[2].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[2].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    width: "50%",
                                                    display: 'inline-block'
                                                  }}
                                                  className="thumbnail-container"
                                                  alt=""
                                                />

                                                <div
                                                  onClick={() => {
                                                    setPlayUrl(val1.videos[3].url);
                                                    setCurrentPlayPlaylist(val1._id);
                                                    setUrlDetails(val1.videos[3]);
                                                    SetVideolist(val1.videos);
                                                    setPlaylistDetails(val1);
                                                  }}
                                                  style={{
                                                    height: "80px",
                                                    cursor: "pointer",
                                                    backgroundImage: `url(${val1.videos[3].thumbnail.includes(".mp4") || val1.videos[3].thumbnail.includes(".mov") ? require("../asset/images/default-thumbnail.webp") : val1.videos[3].thumbnail})`,
                                                    backgroundSize: 'auto 135%',
                                                    backgroundPosition: 'center',
                                                    width: "50%",
                                                    display: 'inline-block'
                                                  }}
                                                  className="thumbnail-container"
                                                  alt=""
                                                />

                                              </>
                                            ) : (""))))}




                                          </>
                                        )}
                                    </div>
                                    <div className="col-4 m-show">
                                      <ins class="adsbygoogle"
                                        style={{ display: "block" }}
                                        data-ad-client="ca-pub-1237383458459832"
                                        data-ad-slot="7118086151"
                                        data-ad-format="auto"
                                        data-full-width-responsive="true"></ins>
                                    </div>
                                  </div>

                                </>) : ("")))}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-2 p-0 m-none flip_bottm_right_adscol"
                          style={{ color: "#fff", height: "130px" }}
                        >
                          <ins class="adsbygoogle"
                            style={{ display: "block" }}
                            data-ad-client="ca-pub-1237383458459832"
                            data-ad-slot="7118086151"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                          {/* {allData[7] ? (
                            <img
                              src={
                                REACT_APP_ADMIN_URL+"/assets/images/reserved/" +
                                allData[7].resimage
                              }
                              className="img-fluid"
                              style={{ width: "95%", height: "145px", marginLeft: "5%" }}
                              alt=""
                            />
                          ) : (
                            <img
                              src={
                                REACT_APP_ADMIN_URL+"/assets/images/reserved/"
                              }
                              className="img-fluid"
                              alt=""
                            />
                          )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </Item>
              </Grid>
            </div>
          </div>

          <Modal show={show.share_embed} onHide={() => { handleClose('share_embed'); }}>
            <Modal.Header closeButton>
              <Modal.Title>Embed Code</Modal.Title>
            </Modal.Header>
            <Modal.Body>  
              <div>
                {document.queryCommandSupported("copy") && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-dark"
                      onClick={copyToClipboard}
                    >
                      Copy
                    </button>{" "}
                    {copySuccess}
                  </div>
                )}
                {UrlDetails ? (
                  <form>
                    <textarea
                      className="embedTextArea"
                      ref={textAreaRef}
                      value={
                        "<iframe width='560' src='" + reactAppUrl + "/playlist?id=" +
                        currentPlayPlaylist +
                        "' title=''YouTube video player' frameborder='0' allow='autoplay; fullscreen; picture-in-picture;' allowfullscreen style='position:absolute;top:0;left:0;width:100%;height:119%;'></iframe>"
                      }
                    />
                  </form>
                ) : (
                  ""
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>

        </div>
      </main>
    </>
  );
}
export default Home;  